module.exports = __webpack_public_path__ + "img/1585852180351777571.7214a360.jpg";